module.exports = __webpack_public_path__ + "img/car.3e46819a.svg";